import type { EpisodeBackup, Id, ScriptDocument } from "@supermanus/document-model";
import {
  exportEpisodeBackup,
  parseEpisodeBackup,
  suggestedEpisodeBackupFilename,
} from "@supermanus/document-model";
import { downloadTextFile } from "./exportFile";

export async function downloadEpisodeBackup(
  doc: ScriptDocument,
  episodeId: Id,
): Promise<void> {
  const backup = exportEpisodeBackup(doc, episodeId);
  const filename = suggestedEpisodeBackupFilename(doc, episodeId);
  downloadTextFile(
    filename,
    `${JSON.stringify(backup, null, 2)}\n`,
    "application/json",
  );
}

export function pickEpisodeBackupFile(): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".smepisode.json,.json,application/json";
    input.onchange = () => {
      resolve(input.files?.[0] ?? null);
    };
    input.oncancel = () => resolve(null);
    input.click();
  });
}

export async function readEpisodeBackupFile(
  file: File,
): Promise<EpisodeBackup> {
  const text = await file.text();
  let raw: unknown;
  try {
    raw = JSON.parse(text) as unknown;
  } catch {
    throw new Error("Filen er ikke gyldig JSON");
  }
  return parseEpisodeBackup(raw);
}
